export var BOOSTING_LEVEL_STATUS;
(function (BOOSTING_LEVEL_STATUS) {
    BOOSTING_LEVEL_STATUS["DEPOSIT"] = "DEPOSIT";
    BOOSTING_LEVEL_STATUS["BUY"] = "BUY";
    BOOSTING_LEVEL_STATUS["BOOST"] = "BOOST";
})(BOOSTING_LEVEL_STATUS || (BOOSTING_LEVEL_STATUS = {}));
